// src/layout/builders/ProjectInvite/PendingApprovalTable.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useProjectStatus from "../../../store/builders/useProjectStatus";
import ProjectTable from "../ProjectTable"; // Reuse the existing table component
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const PendingApprovalTable = () => {
  const navigate = useNavigate();
  const { projects, isLoading, fetchProjects, error } = useProjectStatus();

  useEffect(() => {
    // Fetch only projects with 'pending_approval' status when this component mounts
    fetchProjects("pending_approval");
  }, [fetchProjects]); // Dependency array ensures this runs once on mount

  // No status changes allowed from builder side for pending_approval
  const handleStatusChange = async (projectId, newStatus, comment = null) => {
    console.warn("Builders cannot change the status of pending approval projects.");
    // Optionally show a toast message here
  };

  if (isLoading && projects.length === 0) { // Show loader only if loading and no projects yet
    return (
      <div className="flex justify-center items-center h-64 bg-white rounded-lg shadow mt-4">
        <AiOutlineLoading3Quarters className="animate-spin text-blue-500 text-3xl" />
      </div>
    );
  }

  if (error) {
     return <div className="text-center py-6 text-red-500 text-sm mt-4">{error}</div>;
  }

  // Filter projects locally just in case the store holds others (though fetchProjects should handle it)
  const pendingApprovalProjects = projects.filter(p => p.status === 'pending_approval');

  return (
    <div className="mt-4"> {/* Add margin top for spacing below tabs */}
      <ProjectTable
        title="Pending Invites for Approval"
        // Pass only the projects with 'pending_approval' status
        projects={pendingApprovalProjects}
        handleStatusChange={handleStatusChange} // Pass the no-op handler
        navigate={navigate}
        allowedNextStatuses={[]} // No next statuses allowed for builder
        showActionsColumn={false} // Hide the actions column entirely
      />
       {/* Show message if loading finished but no projects found */}
       {!isLoading && pendingApprovalProjects.length === 0 && (
         <div className="text-center py-10 text-gray-500 text-sm bg-white rounded-lg shadow mt-4">
           No projects are currently pending customer approval.
         </div>
       )}
    </div>
  );
};

export default PendingApprovalTable;